const state = {
	// Проверка аутентификации
	checkAuthState: {},

	// Проверяем, зарегистрирован номер или нет.
	checkRegisteredState: { isExist: false },

	// Генерация проверочного кода
	loginConfirmationCodeState: {},

	// Выход из системы
	logoutState: {},
};

export default state;
